import { type schemaType as howPlatformWorksPageSchemaType } from '~~/shared/api/strapi/how-platform-works-page/schema'

import type { propsInterface } from '~~/modules/design-system/sections/s-hero-angled.vue'

export const useToSHeroAngled = () => {
  const fromStrapiHowPlatformWorksPage = (
    data: howPlatformWorksPageSchemaType,
  ): propsInterface => {
    const filteredData: propsInterface = {
      title: data.attributes.hero.title,
      text: data.attributes.hero.text,
      img: data.attributes.hero.image.data.attributes.url,
    }
    return filteredData
  }

  return { fromStrapiHowPlatformWorksPage }
}
